module.exports = __webpack_public_path__ + "img/ivy-logo-new.f374fde1.png";